import { useHseSummary } from "@dashboard/hooks/useHseSummary";
import { faArrowUpRightDots } from "@fortawesome/pro-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { StatCard } from "./StatCard";

export default function YourImprovements() {
    const { t } = useTranslation();
    const { data: summary, isPending, isError } = useHseSummary();

    const linkHref =
        summary && !Array.isArray(summary.links) ? summary.links.improvements : undefined;

    return (
        <StatCard
            label={t("dashboard.yourImprovements")}
            value={summary?.metrics.improvements.total}
            isPending={isPending}
            isError={isError}
            icon={faArrowUpRightDots}
            variant="green"
            linkHref={linkHref}
            linkLabel={t("dashboard.manageImprovements")}
        />
    );
}
